import React, { useState } from 'react'
import { DescMobileItem } from './DescMobileItem';

export function ToggleDescMobile({ itemsToggle }) {
    const [showDesc, setShowDesc] = useState(itemsToggle)
    const handleClick = (index) => {
        // Change of state of visible at onClick conditional
        setShowDesc(
            showDesc.map(i => (
                i.index === index
                    ? (i?.isDesVisible ? ({ ...i, isDesVisible: false }) : ({ ...i, isDesVisible: true }))
                    : ({ ...i, isDesVisible: false })
            ))
        )
    }
    return (
        <div className="item__service">
            {showDesc.map((item) => (
                <DescMobileItem key={item.index} item={item} handleClick={handleClick} />
            ))}

        </div>
    )
}
